import getType from"./getType";export function isArray(payload){return getType(payload)==="Array"}export default isArray;